import { Component, EventEmitter, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
// import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DomSanitizer } from '@angular/platform-browser';
import Adapter from '../ckeditorAdapter';
@Component({
  selector: 'app-items-fill-in-the-blank-text',
  templateUrl: './items-fill-in-the-blank-text.component.html',
  styleUrls: ['./items-fill-in-the-blank-text.component.scss']
})
export class ItemsFillInTheBlankTextComponent implements OnInit, AfterViewInit {
  display: boolean = true;
  form: FormGroup;
  // editor: Editor;
  fillText: any;
  itemId: any;
  isListMode: boolean = false;
  questionId: string;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  questionuuId: any;
  private routerSubscription: Subscription;
  @Output() postCreated = new EventEmitter();
  isEditMode: boolean = false;
  itemIdForQ: any;
  deletedOptionId: any;
  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    questiondescriptionPreview: 'questiondescriptionPreview',
    description: 'description',
    correctPoints: 'correctPoints',
    maximumcharacterForFreetext: 'maximumcharacterForFreetext',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch',
    options: 'options'
  };
  QuestionScoringType: any;
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  @ViewChild('fibEditor') fibEditor: any;
  editorBtns : any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    sanitize: false,
    height: '5rem',
    minHeight: '5rem',
    // placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    // defaultFontName: 'Arial',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    toolbarHiddenButtons: [['fontName']]
    // toolbarHiddenButtons: [
    //   [
    //     'undo',
    //     'redo',
    //     'link',
    //     'unlink',
    //     'insertVideo',
    //     'insertHorizontalRule',
    //     'customClasses',
    //   ],
    // ],
};
QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
QuestionTypeIdEnum = QuestionTypeIdEnum;
errorMessage: any;
isErrorMessage: boolean = false;
QuestionImages = []
imageId: number = 1;
base64 = [];
imageName: any;
  constructor(
    private fb: FormBuilder,
    private questionService: QuestionService,
    private routerstate: ActivatedRoute,
    private notificationService: NotificationService,
    public itemservice: ItemService,
    private router: Router,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    public _sanitizer: DomSanitizer
  ) {
    // this.editor = new Editor({});
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });
    this.questionId = sessionStorage.getItem('questionuuId');
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }
    this.form = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.FillInTheBlanks),
      questionTypeId: new FormControl(QuestionTypeIdEnum.FillInTheBlanks),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(true),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('true'),
      [this.reuseProp.questiondescriptionPreview]: new FormGroup({ description: new FormControl(''), mediaURL: new FormControl([""]) }),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl(''), mediaURL: new FormControl([""]) }),
      [this.reuseProp.itemId]: new FormControl(JSON.parse(sessionStorage.getItem(this.reuseProp.itemId))),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.penaltyPoints]: new FormControl({ value: 0, disabled: true }),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0,Validators.required),
      [this.reuseProp.options]: new FormArray([], Validators.required),
    });
    this.onChangeQuestion();
    this.questionService.getQuestionScoringType().subscribe(d => {this.QuestionScoringType = d.data})
  }

  get options(): FormArray {
    return <FormArray>this.form.get(this.reuseProp.options);
  }

  onReady(editor) {
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );

    editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
      return new Adapter(loader, editor.config, this.itemservice);
    }
  }

  ngOnInit(): void {
    this.setTotalValueScore();
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.form.patchValue(resdata.data);
          this.form.controls.scoringTypeExactMatch.setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          if (resdata.data.options && resdata.data.options.length) {
            for (let i = 0; i < resdata.data.options.length; i++) {
              this.options.push(this.createOptions(i + 1));
              this.options.controls[i].patchValue({ ...resdata.data.options[i] });
            }
          };
          let value: any;
          value = this.form.value.options.find(ele => ele.correctPoints == 0 );
          if (value != '') this.isInvalid = true;
          if (value == undefined) this.isInvalid = false;

          if (resdata.data.questiondescription.description.includes('Answer') && localStorage.getItem('language') == 'es-ES'){
            const question =  resdata.data.questiondescription.description.replaceAll('Answer', 'Respuesta');
            this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).patchValue(question);
            this.form.controls[this.reuseProp.questiondescription].get(this.reuseProp.description).patchValue(question);
          } else if (resdata.data.questiondescription.description.includes('Answer') && localStorage.getItem('language') == 'pt-PT'){
            const question =  resdata.data.questiondescription.description.replaceAll('Answer','Resposta');
            this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).patchValue(question);
            this.form.controls[this.reuseProp.questiondescription].get(this.reuseProp.description).patchValue(question);
          }
          questionServiceGetSubscription.unsubscribe()
          setTimeout(() => this.convertToPreview(), 0);
        },
          (error) => {
            this.webErrorService.handleAPIErrors(error);
          });
    }
  }

  onChange(event) {
    if (event.includes('<img src=')) {
      this.base64 = [];
      let m;
      let rex = /<img.*?src="([^">]*\/([^">]*?))".*?>/g;   //  regex to find src data->  /<img[^>]+src="?([^"\s]+)"\s*\">/g;
      while ( m = rex.exec( event ) ) {
        this.base64.push({'base64': m[1], name: ''})
      }

      this.base64.forEach(img => {
        if (img.base64.includes('image/jpeg')) {
          this.imageName = (+new Date * Math.random()).toString(36).substring(0,6) + '.jpeg';
          img.name = this.imageName;
          this.isErrorMessage = false;
        } else if (img.base64.includes('image/png')) {
          this.isErrorMessage = false;
          this.imageName = (+new Date * Math.random()).toString(36).substring(0,6) + '.png';
          img.name = this.imageName;
        }else if (img.base64.includes('image/gif')) {
          this.isErrorMessage = false;
          this.imageName = (+new Date * Math.random()).toString(36).substring(0,6) + '.gif';
          img.name = this.imageName;
        }else if (img.base64.includes('image/bmp')) {
          this.isErrorMessage = false;
          this.imageName = (+new Date * Math.random()).toString(36).substring(0,6) + '.bmp';
          img.name = this.imageName;
        } else {
          this.isErrorMessage = true;
          this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).patchValue('')
          this.form.controls[this.reuseProp.questiondescription].get(this.reuseProp.description).patchValue('')
        }
      })
    } else if (event == '' && !this.isErrorMessage) {
      this.isErrorMessage = false;
    }
  }

  onClick(event) {
    if (this.isErrorMessage && event) this.isErrorMessage = false;
  }

  ngAfterViewInit(): void {
    this.editorBtns = this.fibEditor.editorToolbar.__ngContext__[0].children[0].getElementsByClassName('angular-editor-button');
    // this.editorBtns[20].title = 'Note: Select only ';

    // this.editorBtns[20].addEventListener(
    //   "mouseover",
    //   () => {
    //     console.log('Angular editor');
    //   }
    // );
    // Convert HTMLCollection to an array
    const buttonsArray = Array.from(this.editorBtns);
    // // Define your desired order
    const desiredOrder = [2,3,4,5,17,16,6,7,8,9,10,11,12, 13,14,15,18,19,20,21,22,23,24, 0, 1];
    // // Rearrange the array based on the desired order
    const rearrangedArray = desiredOrder.map(index => buttonsArray[index]);
    // // Grab the parent Element
    const parentElement = this.fibEditor.editorToolbar.__ngContext__[0].children[0].getElementsByClassName('angular-editor-toolbar-set')[0];
    // Grab the child Element
    // const childElement = this.fibEditor.editorToolbar.__ngContext__[0].children[0].getElementsByClassName('angular-editor-toolbar-set');
    // console.log('childElement childElement', childElement)
    // const childEleArr = Array.from(childElement)
    // // // Remove existing buttons from the DOM
    // childEleArr.forEach((divEle: HTMLElement) => parentElement.removeChild(divEle));
    // Append the rearranged buttons to the DOM
    rearrangedArray.forEach(button => parentElement.appendChild(button));
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimal(event: any, o, type: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";

    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));
    let num = value.substr(value.length - 1);
    if (type == 'options') {
      if (num != '.') o.controls['correctPoints'].patchValue(parseFloat(value));
    }
    if (type == 'minimumScore') {
      if (num != '.' && value != '') this.form.controls[this.reuseProp.minScoreIfAttempt].patchValue(parseFloat(value));
    }
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if(type == 'options') o.controls['correctPoints'].patchValue(parseFloat(inputElement.value ));
      if(type == 'minimumScore') this.form.controls[this.reuseProp.minScoreIfAttempt].patchValue(parseFloat(inputElement.value));
      if(beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if(type == 'options') o.controls['correctPoints'].patchValue(0);
        if(type == 'minimumScore') this.form.controls[this.reuseProp.minScoreIfAttempt].patchValue(0);
      }
    }
  }

  isInvalid: boolean = true;
  calculateScore(): void {
    let value: any;
    // this.setAndUpdateControl(this.reuseProp.correctPoints, (<FormArray>this.userForm.controls[this.reuseProp.stems]).value.map(d => d.correctPointsforStem).reduce((a, b) => +a + +b));
    this.form.get(this.reuseProp.correctPoints).patchValue(parseFloat(this.form.controls[this.reuseProp.correctPoints].value.toFixed(2)));
    this.form.get(this.reuseProp.correctPoints).updateValueAndValidity();

    value = this.form.value.options.find(ele => ele.correctPoints == 0 );
    if (value != '') this.isInvalid = true;
    if (value == undefined) this.isInvalid = false;
  }

  setTotalValueScore() {
    const totalScore = this.form.get('correctPoints');
    this.form.get('options').valueChanges.subscribe(data => {
      let sum = 0;
      data.forEach(element => {
        sum = sum + element['correctPoints'];
      });
      totalScore.setValue(sum);
    })
  }

  back() {
    this.postCreated.emit('false');
    this.display = false;
    // this.editor.destroy();
  }

  saveQuestion() {
    this.convertToSave();
    if (this.form.valid == true || !this.isInvalid) {
      for (let i = 0; i < this.options.value.length; i++) {
        this.form.controls[this.reuseProp.options]['controls'][i].patchValue({ arrangeOrder: i + 1, });
      }
      if (this.form.controls[this.reuseProp.minScoreIfAttempt].value === null) {
        this.form.controls[this.reuseProp.minScoreIfAttempt].setValue(0);
      }
      if (this.form.controls[this.reuseProp.options]['controls'].length === 1 && this.form.controls.scoringTypeExactMatch.value !== 'true') {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.errMsg1'), true, 'warn')
      } else {

        let question = this.form.value.questiondescription['description'];
        let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g, '').trim();

        this.base64.forEach(img => {
          this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": img.name, "base64": img.base64})
        })

        if (this.QuestionImages.length > 0) {
          this.QuestionImages.forEach(ele => {

            question1 = question1.replace(ele.base64, ele.uniqueId)

            let startIndex = ele.base64.lastIndexOf('base64,');
            ele.base64 = ele.base64.substring(startIndex +7)
          })
        }
        this.form.value.questiondescription['description'] = question1;
        this.form.value.questiondescriptionPreview['description'] = question1;
        this.form.value.questionImages = this.QuestionImages;

        if (this.isEditMode) {
          const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.form.value, this.itemId, this.questionId).subscribe(
            (resData) => {
              this.itemservice.editedGetItem(resData.data);
              this.notificationService.success(resData?.message);
              // this.itemservice.questionCountUpdate.next(true);
              // this.questionService.reloadList.next(true);
              this.isListMode = true;
              questionServiceUpdateSubscription.unsubscribe()
            },
            (error) => {
              this.webErrorService.handleAPIErrors(error, null, true, 'warn');
            });
        } else {
          const questionServicePostSubscription: Subscription = this.questionService.addFillBlankQuestion(this.form.value, this.itemId).subscribe(
            (resData) => {
              this.isListMode = true;
              this.notificationService.success(resData?.message);
              // this.itemservice.questionCountUpdate.next(true);
              // this.questionService.reloadList.next(true);
              this.isEditMode = true;
              this.isListMode = true;
              questionServicePostSubscription.unsubscribe()
            },
            (error) => {
              this.webErrorService.handleAPIErrors(error, null, true, 'warn');
            });
        }
      }
    }
  }
  insertBlank: any;
  addBlank() {
    let insertBlank = `${this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.labelAns')}${this.options.length + 1}`;
    const description = this.form.controls[this.reuseProp.questiondescriptionPreview].value.description;
    const description1 = description.replaceAll('<p>', '').replaceAll('</p>', '');
    const description2 = '<p>' + description1 + '</p>';
    insertBlank = `${description2.substring(0, description2.lastIndexOf("</p>"))} <input type="text" value="${insertBlank} ">  ${description2.substring(description2.lastIndexOf("</p>"), description2.length)}`;
    console.log(insertBlank, 'insertBlank');
    this.insertBlank = insertBlank;

    this.options.push(this.createOptions(this.options.length + 1));
    this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).patchValue(insertBlank);
  }

  convertToSave() {
    this.form.controls[this.reuseProp.questiondescription].get(this.reuseProp.description).patchValue(
      this.form.controls[this.reuseProp.questiondescriptionPreview].value.description.split('<input type="text" value="').join('').split(' ">').join(''));
  }

  convertToPreview() {
    const split = this.form.controls[this.reuseProp.questiondescription].value.description.indexOf(`${this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.labelAns')}1`);
    if (split === -1) {
      this.patchSplits(this.form.controls[this.reuseProp.questiondescription].value.description.split('_'));
    } else {
      let split = this.form.controls[this.reuseProp.questiondescription].value.description;
      if (split.includes('Answer')) { // this condition is added because of language change for split///
        split = split.split(/Answer[1-9]/);
      } else if (split.includes('Respuesta')){
        split = split.split(/Respuesta[1-9]/);
      } else if(split.includes('Resposta')) {
        split = split.split(/Resposta[1-9]/);
      }
      this.patchSplits(split);
    }
  }

  onChangeQuestion() {
    this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).valueChanges.subscribe(data => {
      const splitData = data.split('<input type="text" value="').join('').split(' ">').join('');
      let splits = '';
      if (splitData.includes('Answer')) { // this condition is added because of language change for split///
        splits = splitData.split(/Answer[1-9]/);
      } else if(splitData.includes('Respuesta')) {
        splits = splitData.split(/Respuesta[1-9]/);
      } else if(splitData.includes('Resposta')) {
        splits = splitData.split(/Resposta[1-9]/);
      }

      if (this.options && this.options.value && this.options.value.length !== splits.length) {
        this.deleteOptions(data);
      }
      if (this.options && this.options.value && this.options.value.length === splits.length) {
        for (let i = 1; i <= splits.length; i++) {
          const index = splitData.indexOf(`${this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.labelAns')}${i}`);
          if (index === -1) {
            this.removeOption(i, this.options.value[i - 1]);
          }
        }
      }
    });
  }

  deleteOptions(data: any) {
    if (data === '') {
      this.options.value.forEach(d => {
        this.removeOption(d.optionId, d);
      })
    } else {
      const regex = /<input\s+type="text"\s+value="([^"]+)"\s*\/>/g;
      const matches = data.match(regex);

      if (matches) {
        let result: Array<string> = [];
        matches.forEach((item) => {
          const regex = /<input\s+type="text"\s+value="([^"]+)"\s*\/>/;
          const val = item.match(regex);
          if (val) {
            result.push(val[1]);
          }
        });
        this.options.value.map(option => !result.includes(option.Answer));
        const filteredList = this.filterOptionList(this.options.value, result);
        filteredList.forEach(e => {
          this.removeOption(e.optionId, e);
        });
      }
    }
  }

  filterOptionList(optionArray: any[], blankArray: any[]) {
    return optionArray.filter(option => !blankArray.includes(option.Answer));
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  createOptions(i): FormGroup {
    return this.fb.group({
      Answer: new FormControl(`${this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.labelAns')}${i}`),
      optionId: new FormControl(i),
      id: new FormControl(0),
      modified: new FormControl(this.isEditMode ? true : false),
      arrangeOrder: new FormControl(null),
      answerDescription: new FormGroup({
        description: new FormControl("", Validators.required),
        mediaURL: new FormControl([])
      }),
      answerValid: new FormControl(true),
      correctPoints: new FormControl(0, [Validators.required, Validators.min(0)])
    })
  }

  removeOption(i: number, o) {
    if (this.options.value.length == 1) {
      const question = this.form.controls[this.reuseProp.questiondescriptionPreview].value.description;
      this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).patchValue(question);
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.errMsg2'), true, 'warn')
      return;
    }
    this.options.removeAt(i - 1);
    o.value ? this.deletedOptionId = o.value.id : this.deletedOptionId = o.id;
    let currentEditorValue = this.form?.get(this.reuseProp.questiondescriptionPreview)?.get(this.reuseProp.description)?.value.split('<input type="text" value="').join('').split(' ">').join('');
    currentEditorValue = currentEditorValue.replace(`${this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.labelAns')}${i}`, '');

    if (currentEditorValue.includes('Answer')) { // this condition is added because of language change for split///
      currentEditorValue = currentEditorValue.split(/Answer[1-9]/);
    } else if (currentEditorValue.includes('Respuesta')) {
      currentEditorValue = currentEditorValue.split(/Respuesta[1-9]/);
    } else if (currentEditorValue.includes('Resposta')) {
      currentEditorValue = currentEditorValue.split(/Resposta[1-9]/);
    }

    this.patchSplits(currentEditorValue);

    if (this.questionId) {
      this.questionService.deleteOption(this.questionId, this.deletedOptionId).subscribe((data) => { },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  patchSplits(splits: string[]) {
    let htmlToGenerate = '';
    for (let i = 1; i < splits.length; i++) {
      htmlToGenerate += `${splits[i - 1]} <input type="text" value="${this.translate.instant('questions.typeOfQuestions.fillInTheBlanksText.labelAns')}${i} ">`;
      if (i === splits.length - 1) {
        htmlToGenerate += `${splits[i]}`;
      }
    }
    this.form.controls[this.reuseProp.questiondescriptionPreview].get(this.reuseProp.description).patchValue(htmlToGenerate);
  }
}
